import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 챔피언쉽대회리스트
const get_admintournamentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentlistcnt: 0,
    tournamentlist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/admintournamentlist",
    headers: { Authorization: "Bearer " + token },
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // console.error(response.data.code, response.data.message)
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_admintournamentlist", err);
    result(false, err);
  }
};

// 매장대회리스트
const get_ownertournamentlist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentlistcnt: 0,
    tournamentlist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/ownertournamentlist",
    headers: { Authorization: "Bearer " + token },
    params: {
      startdate: param.startdate,
      enddate: param.enddate,
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        // console.error(response.data.code, response.data.message)
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentlist", err);
    result(false, err);
  }
};

// 매장대회랭킹리스트
const get_ownertournamentranklist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentranklistcnt: 0,
    tournamentranklist: [],
    tournamentname: "",
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentranking/" + param.tournamentno,
    headers: { Authorization: "Bearer " + token },
    params: {
      scoretype: param.scoretype,
      gender: param.gender,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentranklist", err);
    result(false, err);
  }
};

// 매장코스리스트
const get_ownertournamentview = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    tournamentshopname: 0,
    tournamentinfo: [],
    tournamentprizeetc: [],
    tournamentprizerankcnt: "",
    tournamentprizerank: [],
    tournamentdetail: [],
    tournamentcoursecnt: "",
    tournamentcourse: [],
    shophandilist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentinfo/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentview", err);
    result(false, err);
  }
};

// 토너먼트 조건 불러오기
const get_tournamentcondition = async (tournamentno, result) => {
  let finalData = {
    code: "",
    message: "",
    tournamentcondition: [],
    shophandilist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentcondition/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
    //url: 'http://localhost/test.php',
    //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  };
  try {
    await axios(options).then((response) => {
      console.log(response);
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_tournamentcondition", err);
  }
};

// 매장코스리스트
const get_ownertournamentcourselist = async (tournamentno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    courselistcnt: 0,
    courselist: [],
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url: "/tournament/tournamentcourselist/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentcourselist", err);
    result(false, err);
  }
};

// 통합관리대회서브코스리스트
const get_ownertournamentsubcourselist = async (courseno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    subcourselistcnt: 0,
    subcourselist: [],
  };

  const options = {
    method: "GET",
    url: "/tournament/tournamentsubcourselist/" + courseno,
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_ownertournamentsubcourselist", err);
    result(false, err);
  }
};
// 매장대회 등록
const set_ownertournamentwrite = async (form, result) => {
  const token = sessionStorage.getItem("token") || null;
  form.rankprizelist.rankprize.splice(form.rankno);

  form.tour_member_items = form.tour_member_items_.map(
    (v) => v.playerinfo.playerno
  );

  form.subcourseno = form.subcourselist.map((v) => v.subcourseno);

  form.rankno = form.rankno;
  form.rankprize = form.rankprizelist.rankprize;
  console.log("form", form);

  const data = new FormData();

  for (const [key, val] of Object.entries(form)) {
    // 공통 skip
    if (val === undefined || val === null || val === "") continue;

    // 1) File/Blob 우선 처리 (키가 'updatefilename[47]' 같이 이미 bracket 포함이어도 OK)
    if (val instanceof File || val instanceof Blob) {
      data.append(
        key,
        val,
        val instanceof File && val.name ? val.name : `${key}.bin`
      );
      continue;
    }

    // 2) 배열
    if (Array.isArray(val)) {
      Object.keys(val).forEach((i) => {
        const v = val[i];
        if (v === undefined || v === null || v === "") return;
        if (v instanceof File || v instanceof Blob) {
          data.append(
            `${key}[${i}]`,
            v,
            v instanceof File && v.name ? v.name : `${key}[${i}].bin`
          );
        } else {
          data.append(`${key}[${i}]`, v);
        }
      });
      continue;
    }

    // 3) 객체 (예: shop_handi_num 같은 map 구조)
    if (typeof val === "object") {
      Object.keys(val).forEach((i) => {
        const v = val[i];
        if (v === undefined || v === null || v === "") return;
        if (v instanceof File || v instanceof Blob) {
          data.append(
            `${key}[${i}]`,
            v,
            v instanceof File && v.name ? v.name : `${i}.bin`
          );
        } else {
          // Date 같은 건 문자열로 변환하고 싶으면 여기서 toISOString 등 사용
          data.append(`${key}[${i}]`, v);
        }
      });
      continue;
    }

    // 4) 단일 값
    data.append(key, val);
  }

  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite",
    headers: { Authorization: "Bearer " + token },
    data: data,
  };

  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownertournamentwrite", err);
    result(false, err);
  }
};

// 매장대회 수정
const set_ownertournamentedit = async (form, tournamentno, result) => {
  const token = sessionStorage.getItem("token") || null;
  form.rankprizelist.rankprize.splice(form.rankno);
  console.log(form.tour_member_items_);
  form.tour_member_items = form.tour_member_items_.map((v) => v.playerno);

  form.subcourseno = form.subcourselist.map((v) => v.subcourseno);

  form.rankno = form.rankno;
  form.rankprize = form.rankprizelist.rankprize;
  console.log("form", form);
  const data = new FormData();

  for (const [key, val] of Object.entries(form)) {
    // 공통 skip
    if (val === undefined || val === null || val === "") continue;

    // 1) File/Blob 우선 처리 (키가 'updatefilename[47]' 같이 이미 bracket 포함이어도 OK)
    if (val instanceof File || val instanceof Blob) {
      data.append(
        key,
        val,
        val instanceof File && val.name ? val.name : `${key}.bin`
      );
      continue;
    }

    // 2) 배열
    if (Array.isArray(val)) {
      Object.keys(val).forEach((i) => {
        const v = val[i];
        if (v === undefined || v === null || v === "") return;
        if (v instanceof File || v instanceof Blob) {
          data.append(
            `${key}[${i}]`,
            v,
            v instanceof File && v.name ? v.name : `${key}[${i}].bin`
          );
        } else {
          data.append(`${key}[${i}]`, v);
        }
      });
      continue;
    }

    // 3) 객체 (예: shop_handi_num 같은 map 구조)
    if (typeof val === "object") {
      Object.keys(val).forEach((i) => {
        const v = val[i];
        if (v === undefined || v === null || v === "") return;
        if (v instanceof File || v instanceof Blob) {
          data.append(
            `${key}[${i}]`,
            v,
            v instanceof File && v.name ? v.name : `${i}.bin`
          );
        } else {
          // Date 같은 건 문자열로 변환하고 싶으면 여기서 toISOString 등 사용
          data.append(`${key}[${i}]`, v);
        }
      });
      continue;
    }

    // 4) 단일 값
    data.append(key, val);
  }

  const options = {
    method: "POST",
    url: "/tournament/tournamentwrite/" + tournamentno,
    headers: { Authorization: "Bearer " + token },
    data: data,
  };

  try {
    await axios(options).then((response) => {
      // result(true, response.data)
      if (response.data.code === 200) {
        result(true, response.data);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("set_ownertournamentwrite", err);
    result(false, err);
  }
};

// 회원정보보기
const get_playerinfo = async (player, type, result) => {
  let finalData = {
    code: "",
    message: "",
    playerbasicinfo: [],
    playerpalyinfo: [],
  };

  const options = {
    method: "GET",
    url: "/Common/playerinfo",
    params: {
      player: player,
      type: type,
    },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerinfo", err);
    result(false, err);
  }
};

// 통합관리일반회원리스트
const get_playerlist = async (params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/membership/playerlist",
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_playerlist", err);
    result(false, err);
  }
};

// 통합관리일반회원리스트
const get_tourplayerlist = async (tournamentno, params, result) => {
  let finalData = {
    code: 200,
    message: "",
    pageno: 1,
    pagesize: 5,
    playerlistcnt: "0",
    playerlist: [],
  };
  const options = {
    method: "GET",
    url: "/tournament/tourplayerlist/" + tournamentno,
    params: {
      pagesize: 5,
      membertype: params.membertype,
      status: params.status,
      searchtype: params.searchtype,
      searchname: params.searchname,
      pageno: params.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_tourplayerlist", err);
    result(false, err);
  }
};

// 토너먼트참가리스트
const get_admintournamentplaylist = async (tour_pk, player_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    pageno: 1,
    pagesize: 10,
    tournamentname: "",
    tournamentplaylistcnt: 0,
    tournamentplaylist: [],
  };
  const token = sessionStorage.getItem("token") || null;
  console.log("player_pk", player_pk);
  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/tournamentplaylist/" +
      tour_pk +
      "/" +
      player_pk,
    headers: { Authorization: "Bearer " + token },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    console.error("get_membertournamentplaylist", err);
    result(false, err);
  }
};

const get_memberscorecard = async (player_pk, define1_pk, result) => {
  let finalData = {
    code: "",
    message: "",
    scorecardinfo: {},
    scorecardstats: {},
    scorecardscore: {},
    scorecardtotal: {},
  };
  const token = sessionStorage.getItem("token") || null;

  const options = {
    method: "GET",
    url:
      process.env.VUE_APP_API_URL +
      "/tournament/scorecard/" +
      player_pk +
      "/" +
      define1_pk,
    //url: 'http://localhost/test.php',
    headers: { Authorization: "Bearer " + token },
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("get_memberscorecard", err);
    result(false, err);
  }
};

export default {
  get_admintournamentlist,
  get_ownertournamentlist,
  get_ownertournamentranklist,
  get_ownertournamentview,
  get_tournamentcondition,
  get_ownertournamentcourselist,
  get_ownertournamentsubcourselist,
  set_ownertournamentwrite,
  set_ownertournamentedit,
  get_playerinfo,
  get_playerlist,
  get_tourplayerlist,
  get_admintournamentplaylist,
  get_memberscorecard,
};
